import { createContext } from 'react'
import { defaultSelection, useSelection } from './use-selection'


const defaultFunc = () => {
  console.log('%c👻 Missing Context Provider (useSelectionContext)', 'color: LawnGreen')
}

type SelectionStateContextType = ReturnType<typeof useSelection>

export default createContext<SelectionStateContextType>({
  selection: defaultSelection,
  allSelected: false,
  init: defaultFunc,
  update: defaultFunc,
  updateAll: defaultFunc,
})
